import { render, staticRenderFns } from "./ConfirmLeaveModal.vue?vue&type=template&id=536a49e6&scoped=true&"
import script from "./ConfirmLeaveModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmLeaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536a49e6",
  null
  
)

export default component.exports